import React, { useState, useEffect } from "react";
import DynamicSelectInput, {
  StaticSelectInput,
} from "../../constant/SelectInput";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getDivision } from "../../../services/DocumentService";
import { getAuditorList, updateAuditApi } from "../../../services/AuditService";

const EditChecklist = () => {
  const [dataInput, setDataInput] = useState({
    circular_title: "",
    division_id: "",
    auditor_id: "",
    schedule_at: "",
  });
  const [checklist, setChecklist] = useState([
    { checklist_title: "", description: "" },
  ]);
  const [errors, setErrors] = useState({});
  const [division, setDivision] = useState([]);
  const [auditor, setAuditor] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data || {};

  useEffect(() => {
    const fetchDivision = async () => {
      try {
        const resp = await getDivision();
        setDivision(resp.data.data);
      } catch (error) {
        console.error("Error fetching divisions:", error);
      }
    };

    fetchDivision();
  }, []);

  const fetchAuditor = async (divisionId) => {
    try {
      const resp = await getAuditorList(divisionId);
      setAuditor(resp.data.data);
    } catch (error) {
      console.error("Error fetching auditors:", error);
    }
  };

  useEffect(() => {
    if (data) {
      setDataInput({
        id: data.id || "",
        circular_title: data.title || "",
        division_id: data.division.id || [],
        auditor_id: data.schedules[0]?.auditor?.id || "",
        schedule_at: data.schedules[0]?.schedule_at || "",
      });
      const checklist = data.checklist || [];
      setChecklist(
        checklist.map((item) => ({
          checklist_id: item.id || "",
          checklist_title: item.title || "",
          description: item.description || "",
        }))
      );
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setDataInput((prevDataInput) => ({ ...prevDataInput, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setDataInput((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "division_id" && { auditor_id: "" }),
    }));

    if (name === "division_id") {
      fetchAuditor(value);
    }
  };

  const handleDynamicChange = (index, field, value) => {
    const updatedFields = [...checklist];
    updatedFields[index][field] = value;
    setChecklist(updatedFields);
  };

  const addDynamicField = () => {
    setChecklist([...checklist, { checklist_title: "", description: "" }]);
  };

  const removeDynamicField = (index) => {
    const updatedFields = [...checklist];
    updatedFields.splice(index, 1);
    setChecklist(updatedFields);
  };

          
  const handleSubmit = async () => {
    console.log("clicked")
    try {
      setIsSubmitLoading(true);
      const payload = {
        ...dataInput,
        checklist,
      };

      const response = await updateAuditApi(payload);
      toast.success(response.data.message);
      navigate(`/audit/${data.id}`);
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/audit/${data.id}`);
  };

  return (
    <div className="container-fluid">
      <div className="row px-sm-2 px-0">
        <div className="col-xl-12">
          <div className="card px-sm-3 px-1">
            <div className="card-body">
              <h3 className="text-center mb-3">Audit Form</h3>
              <div className="row mb-2">
                <h5>Circular</h5>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Title<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      placeholder="Enter Title"
                      name="circular_title"
                      value={dataInput.circular_title}
                      onChange={handleChange}
                    />
                    {errors.circular_title && (
                      <div className="text-danger">{errors.circular_title}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <StaticSelectInput
                      optionsList={division.map((item) => ({
                        value: item.id,
                        label: item.name,
                      }))}
                      setParentInputValue={handleSelectChange}
                      name="division_id"
                      value={dataInput.division_id}
                      isClearable
                      placeholder="Select Division"
                      label="Division"
                      isRequired={true}
                      defaultValue={{
                        label: data.division?.name,
                        value: data.division?.id,
                      }}
                    />
                    {errors.division_id && (
                      <div className="text-danger">{errors.division_id}</div>
                    )}
                  </div>
                </div>

                <h5 className="mb-3">
                  CheckList <span className="text-danger">*</span>
                </h5>
                {checklist.map((field, index) => (
                  <div className="row mb-4" key={index}>
                    <div className="col-md-6">
                      <input
                        className="form-control"
                        placeholder="Enter Checklist Title"
                        name="checklist_title"
                        value={field.checklist_title}
                        onChange={(e) =>
                          handleDynamicChange(
                            index,
                            "checklist_title",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        className="form-control"
                        placeholder="Enter Description"
                        name="description"
                        value={field.description}
                        onChange={(e) =>
                          handleDynamicChange(
                            index,
                            "description",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-2 d-flex align-items-center">
                      {index === checklist.length - 1 && (
                        <button
                          type="button"
                          className="btn btn-success btn-sm me-2"
                          onClick={addDynamicField}
                        >
                          +
                        </button>
                      )}
                      {checklist.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeDynamicField(index)}
                        >
                          -
                        </button>
                      )}
                    </div>
                    {errors.checklist && (
                      <div className="text-danger mb-2 mt-2">
                        {errors.checklist}
                      </div>
                    )}
                  </div>
                ))}
                <h5>Audit Schedule</h5>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Auditor<span className="text-danger">*</span>
                    </label>
                    <StaticSelectInput
                      parentClassName="mb-0 order"
                      setParentInputValue={handleSelectChange}
                      optionsList={auditor.map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                      name={"auditor_id"}
                      id={"auditor_id"}
                      placeholder={"Select Auditor"}
                      defaultValue={{
                        label: data.schedules[0]?.auditor?.user.name,
                        value: data.schedules[0]?.auditor?.id,
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Schedule At<span className="text-danger">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="schedule_at"
                      value={dataInput.schedule_at}
                      onChange={handleChange}
                    />
                    {errors.schedule_at && (
                      <div className="text-danger">{errors.schedule_at}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-start">
                <button
                  type="button"
                  className="btn btn-primary me-3"
                  onClick={() => handleSubmit()}
                  disabled={isSubmitLoading}
                >
                  {isSubmitLoading ? "Updating..." : "Update"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <div className="container-fluid">
    //   <div className="row px-sm-2 px-0">
    //     <div className="col-xl-12">
    //       <div className="card px-sm-3 px-1">
    //         <div className="card-body">
    //           <h3 className="text-center mb-3">Edit Checklist Form</h3>
    //           <div className="row mb-2">
    //             <h3>Circular</h3>
    //             <div className="col-md-6">
    //               <div className="form-group mb-3">
    //                 <label className="form-label">
    //                   Title<span className="text-danger">*</span>
    //                 </label>
    //                 <input
    //                   className="form-control"
    //                   placeholder="Enter Title"
    //                   name="circular_title"
    //                   value={dataInput.circular_title}
    //                   onChange={handleChange}
    //                 />
    //                 {errors.circular_title && (
    //                   <div className="text-danger">{errors.circular_title}</div>
    //                 )}
    //               </div>
    //             </div>
    //             <div className="col-md-6">
    //               <div className="form-group mb-3">
    //                 <StaticSelectInput
    //                   optionsList={division.map((item) => ({
    //                     value: item.id,
    //                     label: item.name,
    //                   }))}
    //                   setParentInputValue={handleSelectChange}
    //                   name="division_id"
    //                   value={dataInput.division_id}
    //                   isClearable
    //                   placeholder="Select Division"
    //                   is_multi
    //                   label="Division"
    //                 />
    //                 {errors.division_id && (
    //                   <div className="text-danger">{errors.division_id}</div>
    //                 )}
    //               </div>
    //             </div>
    //             <div className="col-md-12">
    //               <div className="form-group mb-3">
    //                 <label className="form-label">Remarks</label>
    //                 <textarea
    //                   className="form-control"
    //                   placeholder="Enter Remarks"
    //                   name="remarks"
    //                   value={dataInput.remarks}
    //                   onChange={handleChange}
    //                 />
    //               </div>
    //             </div>

    //             <h3>Checklist</h3>
    //             <div className="col-md-6">
    //               <div className="form-group mb-3">
    //                 <label className="form-label">
    //                   Title<span className="text-danger">*</span>
    //                 </label>
    //                 <input
    //                   className="form-control"
    //                   placeholder="Enter Checklist Title"
    //                   name="checklist_title"
    //                   value={dataInput.checklist_title}
    //                   onChange={handleChange}
    //                 />
    //                 {errors.checklist_title && (
    //                   <div className="text-danger">{errors.checklist_title}</div>
    //                 )}
    //               </div>
    //             </div>
    //             <div className="col-md-6">
    //               <div className="form-group mb-3">
    //                 <label className="form-label">
    //                   Description<span className="text-danger">*</span>
    //                 </label>
    //                 <textarea
    //                   className="form-control"
    //                   placeholder="Enter Description"
    //                   name="description"
    //                   value={dataInput.description}
    //                   onChange={handleChange}
    //                 />
    //                 {errors.description && (
    //                   <div className="text-danger">{errors.description}</div>
    //                 )}
    //               </div>
    //             </div>

    //             <h3>Audit Schedule</h3>
    //             <div className="col-md-6">
    //               <div className="form-group mb-3">
    //                 <label className="form-label">
    //                   Auditor<span className="text-danger">*</span>
    //                 </label>
    //                 <DynamicSelectInput
    //                   parentClassName="mb-0 order"
    //                   setParentInputValue={handleSelectChange}
    //                   endpoint_name="search_auditor"
    //                   name="auditor_id"
    //                   id="auditor_id"
    //                   placeholder="Select Auditor"
    //                 />
    //               </div>
    //             </div>
    //             <div className="col-md-6">
    //               <div className="form-group mb-3">
    //                 <label className="form-label">
    //                   Schedule At<span className="text-danger">*</span>
    //                 </label>
    //                 <input
    //                   type="datetime-local"
    //                   className="form-control"
    //                   name="schedule_at"
    //                   value={dataInput.schedule_at}
    //                   onChange={handleChange}
    //                 />
    //                 {errors.schedule_at && (
    //                   <div className="text-danger">{errors.schedule_at}</div>
    //                 )}
    //               </div>
    //             </div>
    //           </div>

    //           <div className="d-flex align-items-center justify-content-start">
    //             <button
    //               type="button"
    //               className="btn btn-primary me-3"
    //               onClick={handleSubmit}
    //               disabled={isSubmitLoading}
    //             >
    //               {isSubmitLoading ? "Submitting..." : "Submit"}
    //             </button>
    //             <button
    //               type="button"
    //               className="btn btn-secondary"
    //               onClick={handleCancel}
    //             >
    //               Cancel
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default EditChecklist;
